// src/components/guide/AiHelpSection.js
// Step 0, shown once the instructions are read: optional help from an AI assistant, collapsed.
// TODO(K8): approve wording.
import React from "react";
import { Accordion, AccordionDetails, AccordionSummary, Box, Button, Typography } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import SmartToyOutlinedIcon from "@mui/icons-material/SmartToyOutlined";

export default function AiHelpSection({ onOpenAssistant }) {
  return (
    <Accordion
      disableGutters
      sx={{ mb: 3, border: "1px solid", borderColor: "divider", borderRadius: 2, boxShadow: "none", "&:before": { display: "none" } }}
    >
      <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="ai-help-content" id="ai-help-header">
        <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
          <SmartToyOutlinedIcon color="primary" />
          <Box>
            <Typography variant="body1" sx={{ fontWeight: 600 }}>
              Optional: prepare your answers with an AI assistant
            </Typography>
            <Typography variant="body2" color="text.secondary">
              Mistral Vibe, Claude, ChatGPT or any other chatbot
            </Typography>
          </Box>
        </Box>
      </AccordionSummary>
      <AccordionDetails sx={{ pt: 0, pl: { sm: 7 } }}>
        <Typography variant="body2" sx={{ mb: 1 }}>
          Connect your own AI assistant. It asks you questions in its chat and pre-fills steps 1–3 here. For step 4 it can send a summary of what the learner already knows (for example from a CV), and the tool marks the matching MLUs.
          You still review and confirm every step in this tool.
        </Typography>
        {onOpenAssistant && (
          <Button variant="outlined" size="small" startIcon={<SmartToyOutlinedIcon />} onClick={onOpenAssistant} sx={{ mb: 2 }}>
            Set up your AI assistant
          </Button>
        )}
        <Typography variant="body2" color="text.secondary">
          No assistant? In steps 1–3, use <strong>Prepare with any AI chatbot</strong> to copy a prompt into any chatbot
          and paste its answer back.
        </Typography>
      </AccordionDetails>
    </Accordion>
  );
}
